// extracted by mini-css-extract-plugin
export var arrow = "_2g-6";
export var changeItem = "_2g-3";
export var changesHeader = "_2g-1";
export var changesList = "_2g-2";
export var container = "_2g-0";
export var pathLabel = "_2g-4";
export var value = "_2g-7";
export var valuesContainer = "_2g-5";